import options from "./SidebarOptions";
import SidebarUser from "./SidebarUser";
import SidebarMenu from "./SidebarMenu";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { withRouter } from "react-router";

function Sidebar(props) {
  const { isSidebarOpen } = useSelector((state) => state.Layout);
  const [currentPath, setCurrentPath] = useState();

  useEffect(() => {
    const body = document.getElementsByTagName("body");
    if (body && body.length) {
      if (isSidebarOpen) {
        body[0].classList.remove("sidebar-icon-only");
      } else {
        body[0].classList.add("sidebar-icon-only");
      }
    }
  }, [isSidebarOpen]);

  useEffect(() => {
    const activeTab = getActiveTab();
    if (activeTab?.length) {
      setCurrentPath(activeTab);
    }
  }, [props]);

  const getActiveTab = () => {
    const activeTab = props.history.location.pathname.split("/");

    return activeTab;
  };

  const isActive = (path, index = 2) => {
    if (currentPath?.length) {
      return currentPath[index] === path;
    }
    return false;
  };

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <SidebarUser />
      <ul className="nav">
        {options.map((singleOption) => (
          <SidebarMenu
            key={singleOption.key}
            singleOption={singleOption}
            isActive={isActive(singleOption.path, singleOption?.activeIndex)}
          />
        ))}
      </ul>
    </nav>
  );
}

export default withRouter(Sidebar);
